import { SimpleSearchFilter } from 'api/dashboard/widget';
import { Filter } from 'components/molecules/filters/types';
import { FieldGroup } from 'components/molecules/views';
import { ColumnOrder } from 'components/organisms/grid-custom-column';
import { GroupedFilter } from '../grouped-filter-popover';

export enum TaskCompletionType {
  All = 'all',
  Incomplete = 'incomplete',
  Complete = 'complete',
}

export interface ApiTasksViewDefinition {
  filter?: SimpleSearchFilter;
  group: { row?: FieldGroup | null; column: FieldGroup };
  columnOrder?: ColumnOrder[];
}
export interface TasksViewDefinition {
  filter: Filter;
  groupBy?: { rowGroup: string | null; columnGroup: string | null };
  columnOrder?: ColumnOrder[];
}

export interface GroupedFilterViewDefinition {
  filter: GroupedFilter;
  groupBy?: { rowGroup: string | null; columnGroup: string | null };
  columnOrder?: ColumnOrder[];
}
